<div *ngFor="let notification of notifications">
  <div aria-live="assertive">
    <div
      data-component="alert-message"
      [maxCharacters]="notification.maxCharacters"
      [dismissable]="notification.dismissable"
      [dismissType]="notification.dismissType"
      [dismissCookieName]="notification.uniqueName"
      [data]="{
        category: typeAlertMapping[notification.type],
        message: notification.message
      }"
    ></div>
  </div>
</div>
